import { AbbreviatedText } from 'ui/AbbreviatedText';
import { invoicesHelpers } from 'utils/helpers/invoices';
import type { TComponent } from 'utils/types/component';

import type { IPaymentInvoice } from 'models/Invoice/Payment';

import styles from './UserIdCell.module.scss';

interface IUserIdCellProps {
    record: IPaymentInvoice;
}

export const UserIdCell: TComponent<IUserIdCellProps> = (props) => {
    const { record } = props;

    const userId = record.userId;

    return (
        <AbbreviatedText
            text={userId}
            formatFunction={invoicesHelpers.formatIdentity}
            className={styles.text}
        />
    );
};
